jQuery.noConflict();

(function($) {
    $(document).ready(function() {
        /*For hosting testing - disable in Prd */
	$('.footerCopyright .right').append('<div style="color: white; padding-top: 130px; padding-left: 250px;">MFFWeb-NCal1a</div>');
    });
}(jQuery));
